export const enum Colors {
  RED = '#F53F3F',
  ORANGERED = '#FF5722',
  ORANGE = '#FF7D00',
  YELLOW = '#FFB400',
  CYAN = '#0FC6C2',
  GREEN = '#00B42A',
  LIME = '#7BC616',
  ARCOBLUE = '#168CFF',
  BLUE = '#165DFF',
  PURPLE = '#7816FF',
  PINKPURPLE = '#B71DE8',
  MAGENTA = '#EB0AA4',
  GRAY = '#86909C',
}
